<template>
    <div>
        <div class="row">
            <div class="pay-logo">
                <img v-for="(paymentLogo, index) in paymentLogos" class="paymentLogo lazy" :src="paymentLogo.image.url"
                     :alt="paymentLogo.image.alt" :key="'paymentLogo-' + index">
            </div>
        </div>
        <div class="infotext">
            <p class="no-margin">{{ lang.inclusive }} {{
                    insuranceTax !== 0 ?
                        currencyFormatter.format(insuranceTax.toFixed(2)) + lang.insurance_tax : ''
                }}
                {{ currencyFormatter.format(fees.toFixed(2)) }} {{ lang.insurance_package }}</p>
        </div>
    </div>
</template>

<script>
export default {
  name: "PaymentMethodFooter",
  props: [
    'productId','smmProduct','disableSepa', 'disableCreditcard', 'lang', 'currencyFormatter', 'pricing', 'paymentLogos',
    'bundleServices'
  ],
  computed: {
    fees: function () {
      return Math.max(0, this.serviceFees + this.transferFees);
    },
    serviceFees: function () {
      return this.pricing.serviceFee + this.bundleServices.bundleServiceFee || 0;
    },
    transferFees: function () {
      return this.pricing.transferFee + this.bundleServices.bundleTransferFee || 0;
    },
    insuranceTax: function () {
        return this.pricing.insuranceTax + this.bundleServices.bundleInsuranceTax || 0;
    }
  },
}
</script>
<style scoped>
.pay-logo{
  display: flex;
}
.paymentLogo{
  margin: auto;
  display: block;
  width: 20%;
}
</style>
